

export enum SupplierName {
  FR_ilyes = 'FR_ilyes',
  aliexpress = 'aliexpress',
}

export const EBAY_marketplace_to_lang: Record<string, string> = {
  'EBAY_FR': 'FR',
}